var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConceptStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5873 14.9369C28.5873 17.0237 26.67 18.7105 24.305 18.7105H7.10639C3.60233 18.7105 0.763428 16.2064 0.763428 13.1153C0.763428 12.9545 0.772123 12.798 0.785165 12.6414C0.780818 12.6371 0.780818 12.6328 0.785165 12.6284C1.02428 10.2199 2.98934 8.25484 5.58478 7.69402C5.8065 4.3769 8.91929 1.74667 12.7364 1.74667C15.7405 1.74667 18.3098 3.37698 19.3793 5.68549C19.5532 5.6681 19.7271 5.6594 19.9097 5.6594C22.3139 5.6594 24.292 7.25927 24.5398 9.31563C24.5615 9.46344 24.5702 9.6156 24.5702 9.76342C24.5702 9.94166 24.5572 10.1069 24.5311 10.2764C24.4876 10.5851 24.4007 10.8807 24.2833 11.1677H24.305C26.5005 11.1677 28.309 12.6197 28.5568 14.4935C28.5786 14.6369 28.5873 14.7891 28.5873 14.9369Z",
    fill: "#EDEDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5702 8.87218C24.5702 9.02 24.5615 9.17216 24.5398 9.31562C24.292 7.25927 22.3139 5.6594 19.9097 5.6594C19.7271 5.6594 19.5532 5.66809 19.3793 5.68548C18.3098 3.37263 15.7405 1.74667 12.7364 1.74667C8.91929 1.74667 5.8065 4.38124 5.58478 7.69402C2.98934 8.25919 1.02428 10.2242 0.785165 12.6284C0.767775 12.4936 0.763428 12.3632 0.763428 12.2241C0.763428 9.59821 2.81544 7.40274 5.58478 6.80278C5.8065 3.48131 8.91929 0.851089 12.7364 0.851089C15.7405 0.851089 18.3098 2.48574 19.3793 4.79425C19.5532 4.77686 19.7271 4.76382 19.9097 4.76382C22.4834 4.76382 24.5702 6.6028 24.5702 8.87218ZM28.5873 14.0457C28.5873 14.1978 28.5786 14.35 28.5568 14.4935C28.309 12.6197 26.5005 11.1676 24.305 11.1676H24.2833C24.4007 10.8851 24.4876 10.5894 24.5311 10.2764C26.7918 10.3808 28.5873 12.0241 28.5873 14.0457Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1748 16.7454H7.17603V28.1445H22.1748V16.7454Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5144 20.4712H15.2366V25.7491H20.5144V20.4712Z",
    fill: "#F5F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6533 23.3275H15.6187V25.3621H17.6533V23.3275Z",
    fill: "#D80808"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1274 20.8538H18.0928V22.8884H20.1274V20.8538Z",
    fill: "#D80808"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6533 20.8538H15.6187V22.8884H17.6533V20.8538Z",
    fill: "#D80808"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1274 23.3275H18.0928V25.3621H20.1274V23.3275Z",
    fill: "#D80808"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3839 21.0581H8.84082V28.1489H13.3839V21.0581Z",
    fill: "#F5F0F0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9972 21.4407H9.22363V24.5752H12.9972V21.4407Z",
    fill: "#D80808"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9972 25.0143H9.22363V28.1488H12.9972V25.0143Z",
    fill: "#D80808"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91508 16.7454H5.66309L8.70632 12.7762H10.1975L7.91508 16.7454Z",
    fill: "#E5E5E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1668 16.7454H7.91479L10.1972 12.7762H11.6928L10.1668 16.7454Z",
    fill: "#EA1717"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4231 16.7454H10.1667L11.6927 12.7762H13.1839L12.4231 16.7454Z",
    fill: "#E5E5E5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6751 16.7454H12.4231L13.1839 12.7762H14.6751V16.7454Z",
    fill: "#EA1717"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9273 16.7454H14.6753V12.7762H16.1708L16.9273 16.7454Z",
    fill: "#E5E5E5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1837 16.7454H16.9274L16.1709 12.7762H17.6621L19.1837 16.7454Z",
    fill: "#EA1717"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.436 16.7454H19.184L17.6624 12.7762H19.1579L21.436 16.7454Z",
    fill: "#E5E5E5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6875 16.7454H21.4355L19.1575 12.7762H20.6487L23.6875 16.7454Z",
    fill: "#EA1717"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78908 19.0235C6.16739 19.0235 5.66309 18.5192 5.66309 17.8975V16.7498H7.91508V17.8975C7.91508 18.5192 7.41077 19.0235 6.78908 19.0235Z",
    fill: "#E5E5E5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04079 19.0235C8.4191 19.0235 7.91479 18.5192 7.91479 17.8975V16.7498H10.1668V17.8975C10.1668 18.5192 9.66248 19.0235 9.04079 19.0235Z",
    fill: "#EA1717"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2974 19.0235C10.6757 19.0235 10.1714 18.5192 10.1714 17.8975V16.7498H12.4234V17.8975C12.4234 18.5192 11.9191 19.0235 11.2974 19.0235Z",
    fill: "#E5E5E5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5491 19.0235C12.9274 19.0235 12.4231 18.5192 12.4231 17.8975V16.7498H14.6751V17.8975C14.6751 18.5192 14.1708 19.0235 13.5491 19.0235Z",
    fill: "#EA1717"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8013 19.0235C15.1796 19.0235 14.6753 18.5192 14.6753 17.8975V16.7498H16.9273V17.8975C16.9273 18.5192 16.423 19.0235 15.8013 19.0235Z",
    fill: "#E5E5E5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0535 19.0235C17.4318 19.0235 16.9275 18.5192 16.9275 17.8975V16.7498H19.1795V17.8975C19.1838 18.5192 18.6795 19.0235 18.0535 19.0235Z",
    fill: "#EA1717"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3096 19.0235C19.6879 19.0235 19.1836 18.5192 19.1836 17.8975V16.7498H21.4356V17.8975C21.4356 18.5192 20.9313 19.0235 20.3096 19.0235Z",
    fill: "#E5E5E5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22.562 19.0235C21.9403 19.0235 21.436 18.5192 21.436 17.8975V16.7498H23.688V17.8975C23.688 18.5192 23.1837 19.0235 22.562 19.0235Z",
    fill: "#EA1717"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6486 12.7762H8.70605V12.2719C8.70605 11.9241 8.98864 11.6371 9.34079 11.6371H20.0182C20.366 11.6371 20.6529 11.9197 20.6529 12.2719V12.7762H20.6486Z",
    fill: "#725151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConceptStore);
export default __webpack_public_path__ + "static/media/ConceptStore.503ae41d1848f24034f6f44b12fc85d6.svg";
export { ForwardRef as ReactComponent };